import { useEffect, useState } from 'react';
import { getAuthenticatedBlobUrl } from '../utils/authenticatedStorage';

export function useAuthenticatedMediaUrl(storageUrl: string | undefined): {
  url: string;
  loading: boolean;
  error: boolean;
} {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(!!storageUrl);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!storageUrl) {
      setUrl('');
      setLoading(false);
      setError(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);

    void getAuthenticatedBlobUrl(storageUrl)
      .then((blobUrl) => {
        if (!cancelled) {
          setUrl(blobUrl);
          setError(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setUrl('');
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [storageUrl]);

  return { url, loading, error };
}
